import type { CreateAxiosDefaults } from 'axios'

export const AXIOS_DEFAULT_OPTIONS: CreateAxiosDefaults = {
    timeout: 60000,
    withCredentials: false,
}
